'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _applicationState = require('./applicationState');

var _adsSettings = require('./adsSettings');

var _adsSettings2 = _interopRequireDefault(_adsSettings);

var _parseUtils = require('./parseUtils');

var _parseUtils2 = _interopRequireDefault(_parseUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ONE_HOUR_IN_MILLISECONDS = 3600000;

function addIfExists(targeting, key, value) {
  if (targeting && key && !(0, _isNil2.default)(value)) {
    targeting[key] = value;
  }
}

function toTargetingBool(value) {
  return _parseUtils2.default.parseBool(value) ? 'true' : 'false';
}

function determineNewUser() {
  var isFirstVisit = (0, _applicationState.getState)(_applicationState.State.isFirstVisit);
  var firstVisitTime = (0, _applicationState.getState)(_applicationState.State.firstVisitTime);
  var firstVisitTimePlusOneHour = firstVisitTime + ONE_HOUR_IN_MILLISECONDS;
  return Boolean(isFirstVisit && firstVisitTimePlusOneHour > Date.now());
}

function getEnv() {
  var envsMap = {
    local: 'dev',
    development: 'dev',
    stage: 'stage',
    pr: 'dev',
    qa: 'dev',
    experimental: 'dev',
    itg: 'stage',
    production: 'prod'
  };
  return envsMap[(0, _applicationState.getState)(_applicationState.State.env)] || 'prod';
}

var targetBuilder = {
  build: function build() {
    var targeting = {};

    var guideItemDetail = _adsSettings2.default.getGuideItemDetails();
    addIfExists(targeting, 'stationId', guideItemDetail.stationId);
    addIfExists(targeting, 'programId', guideItemDetail.programId);
    addIfExists(targeting, 'topicId', guideItemDetail.topicId);
    addIfExists(targeting, 'uploadId', guideItemDetail.audioClipId);
    addIfExists(targeting, 'language', (0, _applicationState.getState)(_applicationState.State.language));
    addIfExists(targeting, 'country_region_id', (0, _applicationState.getState)(_applicationState.State.countryRegionId));
    addIfExists(targeting, 'station_language', (0, _applicationState.getState)(_applicationState.State.stationLanguage));
    addIfExists(targeting, 'is_new_user', toTargetingBool(determineNewUser()));
    addIfExists(targeting, 'is_family', toTargetingBool(_adsSettings2.default.isFamilyContent()));
    addIfExists(targeting, 'is_mature', toTargetingBool(_adsSettings2.default.isMatureContent()));
    addIfExists(targeting, 'is_event', toTargetingBool(_adsSettings2.default.isEvent()));
    addIfExists(targeting, 'is_ondemand', toTargetingBool(_adsSettings2.default.isOnDemand()));
    addIfExists(targeting, 'class', _adsSettings2.default.getClass());
    addIfExists(targeting, 'genre_id', _adsSettings2.default.getGenreId());
    addIfExists(targeting, 'lotamesegments', (0, _applicationState.getState)(_applicationState.State.lotamesegments));
    addIfExists(targeting, 'isFirstInSession', toTargetingBool((0, _applicationState.getState)(_applicationState.State.isFirstInSession)));
    addIfExists(targeting, 'categoryId', (0, _applicationState.getState)(_applicationState.State.categoryId));
    addIfExists(targeting, 'screen', (0, _applicationState.getState)(_applicationState.State.currentScreen));

    if (!(0, _applicationState.getState)(_applicationState.State.isOptedOut)) {
      addIfExists(targeting, 'IDL', (0, _get2.default)((0, _applicationState.getState)(_applicationState.State.config), 'targetingIdl'));
    }

    // This is true to call a leave behind banner
    var videoPrerollPlayed = (0, _applicationState.getState)(_applicationState.State.videoPrerollPlayed);
    addIfExists(targeting, 'videoPrerollPlayed', toTargetingBool(videoPrerollPlayed));

    var options = (0, _applicationState.getState)(_applicationState.State.options);
    if (options) {
      var isScreenBigEnoughForUnlock = (0, _applicationState.getState)(_applicationState.State.isScreenBigEnoughForVideoAds);
      addIfExists(targeting, 'persona', options['ads.persona']);
      addIfExists(targeting, 'abtest', options['abtest.ids']);
      var unlockEnabled = toTargetingBool(options['unlockedContent.enabled'] && isScreenBigEnoughForUnlock);
      addIfExists(targeting, 'unlockEnabled', unlockEnabled);
    }

    var unlockDetails = (0, _applicationState.getState)(_applicationState.State.unlockDetails);
    if (unlockDetails) {
      addIfExists(targeting, 'campaignId', unlockDetails.CampaignId);
      addIfExists(targeting, 'nflUnlocks', unlockDetails.NflUnlocks);
    }

    addIfExists(targeting, 'isUnlocked', toTargetingBool(_adsSettings2.default.isUnlocked()));

    addIfExists(targeting, 'isLoggedIn', toTargetingBool((0, _applicationState.getState)(_applicationState.State.isRegisteredUser)));

    var _getState = (0, _applicationState.getState)(_applicationState.State.ccpaStatus, {}),
        ccpaStatus = _getState.value;

    addIfExists(targeting, 'us_privacy', ccpaStatus);

    addIfExists(targeting, 'partnerId', (0, _applicationState.getState)(_applicationState.State.partnerId));

    addIfExists(targeting, 'premium', toTargetingBool(_adsSettings2.default.isPremium()));

    addIfExists(targeting, 'env', getEnv());

    addIfExists(targeting, 'ipAddress', (0, _applicationState.getState)(_applicationState.State.ipAddress));

    addIfExists(targeting, 'ads_partner_alias', (0, _get2.default)((0, _applicationState.getState)(_applicationState.State.config), 'targeting.ads_partner_alias'));

    return targeting;
  }
};

exports.default = targetBuilder;